<template>
    <dynamic-form-input :type="data.type.value" :placeholder="data.placeholder" :help="data.placeholder" :rules="{required: rules && data.required}" :disabled="disabled"
                        :color="color"
                        :label="data.label"
                        v-model="submitValue" :options="previewOptions"/>
</template>

<script>
import FormInputsMixin from "../FormInputsMixin";
    import Inputtable from "../../../mixins/Inputtable";

    export default {

        name: 'CustomFormInput',
        mixins: [FormInputsMixin, Inputtable],

        props: {
            // Whether to apply validation rules on the inputs
            rules: {
                type: Boolean,
                default: true
            },

            color: {
                type: String,
                default: null
            }
        },

        data() {
            return {
                initialValue: this.value
            }
        },

        computed: {
            previewOptions() {
                return this.data.options && this.data.options.length ? this.data.options.map(option => {
                    // Allow the option to be selected on edit when it was initially selected even though the option is out of stock
                    const selectedCount = this.edit ? (option.selected_count - (this.initialValue === option.text ? 1 : 0)) : option.selected_count;
                    const isSelectable = !option.max_selectable_count || (option.max_selectable_count > selectedCount);

                    return {value: option.text, help: option.help, text: option.text, disabled: !isSelectable, subtitle: option.max_selectable_count ? this.$t('text.remaining_stock_count', {count: option.max_selectable_count - selectedCount}) : null}
                }) : [];
            },
        }

    }
</script>